export var RETRIABLE_OPERATIONS = ["BuyBox"];